import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { EmailLog } from '@/services/emailLogs/emailLogs.type';
import * as React from 'react';
import { getColumns } from './Column';

export const EmailLogsTable = ({
  data,
  isLoading = false,
  pagination,
}: {
  data: EmailLog[];
  isLoading: boolean;
  pagination: Pagination;
}) => {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );
  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'emailRequestedId', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: t('logsManagement.emailLogs.crumb.emailLogs'),
      loading: isLoading,
      totalPage: pagination.totalItems,
    },
    getRowId: (originalRow) => String(originalRow.emailRequestedId),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <div>
      <DataTable table={table} className="rounded-lg">
        <DataTableToolbar defaultDatePreset="today" />
      </DataTable>
    </div>
  );
};
